import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import '../styles/Common.css';
import { buildHansemApiUrl } from '../config/api';

const StockHanssemPage = () => {
const [uploadMessage, setUploadMessage] = useState('');
const [isUploading, setIsUploading] = useState(false); // ✅ 상태 추가

const handleFile = async (file) => {
  setIsUploading(true);         // ✅ 업로드 시작 알림
  setUploadMessage('📤 업로드 중입니다...');

  try {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const sheet = workbook.Sheets['원단공유'];

    if (!sheet) {
      setUploadMessage('❌ "원단공유" 시트를 찾을 수 없습니다.');
      setIsUploading(false);
      return;
    }


   let jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });


// 필터: 8~10번째 열 제외
const filtered = jsonData
  .map(row => row.filter((_, index) => ![7, 8, 9].includes(index)))
  .filter(row => row.length > 0);
  

// 열 개수 기준을 첫 행(헤더)로 고정
const targetColCount = filtered[0]?.length || 0;

// ✅ 모든 행의 열 수 맞춰주기
const padded = filtered.map(row => {
  const copy = [...row];
  while (copy.length < targetColCount) {
    copy.push('');
  }
  return copy;
});
console.log(padded[0]); // 헤더 확인
console.log(padded[1]); // 데이터 예시 확인

    const payload = { rangeData: padded };
      console.log(padded)
    const res = await fetch(buildHansemApiUrl('/api/hansem'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const text = await res.text();

    if (res.ok && text.trim().toLowerCase().includes('success')) {
      setUploadMessage(`✅ 업로드 성공`);
      alert('✅ 엑셀 업로드가 완료되었습니다!');
    } else {
      setUploadMessage(`❌ 서버 응답 오류:\n${text}`);
    }
  } catch (error) {
    console.error(error);
    setUploadMessage(`❌ 업로드 실패: ${error.message}`);
  } finally {
    setIsUploading(false);
  }
};

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      handleFile(e.target.files[0]);
    }
  };

  return (
  <div className="common-container">
    <h1>한샘 재고 페이지</h1>

    <div
      onDrop={handleDrop}
      onDragOver={(e) => e.preventDefault()}
      style={{
        border: '2px dashed #1890ff',
        padding: '40px',
        textAlign: 'center',
        marginBottom: '20px',
        borderRadius: '8px',
        backgroundColor: '#fafafa'
      }}
    >
      엑셀 파일을 여기에 드래그하거나 아래 버튼을 이용해 업로드하세요.
    </div>

    <input
      type="file"
      accept=".xlsx, .xls"
      onChange={handleFileChange}
      style={{ marginBottom: '10px' }}
    />

    {/* ✅ 여기에 추가합니다 */}
    {isUploading && (
      <div style={{ color: '#1890ff', marginTop: '10px' }}>
        📡 서버로 업로드 중...
      </div>
    )}

    {uploadMessage && (
      <div
        style={{
          marginTop: '10px',
          whiteSpace: 'pre-wrap',
          color: uploadMessage.startsWith('✅') ? 'green' : 'red'
        }}
      >
        {uploadMessage}
      </div>
    )}
  </div>
);

};

export default StockHanssemPage;
